/**
 * ListingsBrowseControls — what the listings browse navbar puts in
 * `NavbarShell`'s centre slot: the location/listing omnibox and the filters
 * control, together.
 *
 * This was `ListingsSearchBar`, and the rename is the change: the slot held
 * only the omnibox, so the desktop hub could search but not FILTER while the
 * mobile top bar could filter but not sort (obs. 2). The filters trigger could
 * not come here because it lived in `ListingsClient` — a feature component —
 * and `infra → feature` is refused by the element DAG. The remedy is the one
 * `MarketingNavbar` and this file's own omnibox already took: the control is
 * PROMOTED to a layer both placements may reach
 * (`shared/components/listings/filters/`, `entity`), never the DAG widened.
 *
 * The omnibox is pinned to the CURRENT browse mode so selecting a
 * district/estate STAYS on the active mode (`/listings/rent?district_id=…` vs
 * `/listings/buy?…`), and the mode is the matched ROUTE's — stated by its
 * loader as `browseScope` under a generated obligation, never read back out of
 * the path. That derivation lives with the filter scope in
 * `useListingsCanvasScope`, so the two controls beside each other cannot read
 * the same page differently.
 *
 * ★ It lives beside `NavbarShell` rather than under
 * `features/storefront/listings/components/` for the reason `MarketingNavbar`
 * (now `SiteNavbar`) was moved here before it: it IS page chrome — the content
 * of the navbar's centre slot — and with `PageShell` composing chrome from one
 * table, the navbar is assembled in `infra`.
 */
import { ListingsFiltersControl } from '@/shared/components/listings/filters/ListingsFiltersControl';
import { useListingsCanvasScope } from '@/shared/components/listings/filters/use-listings-browse-scope';
import { SearchBar } from '@/shared/components/search';

export function ListingsBrowseControls() {
  const { urlMode } = useListingsCanvasScope();
  return (
    <div className="flex w-full items-center gap-2">
      <div className="min-w-0 flex-1">
        <SearchBar variant="navbar" mode={urlMode} />
      </div>
      <ListingsFiltersControl className="shrink-0" />
    </div>
  );
}
